import Swiper, { Autoplay } from 'swiper'
import 'swiper/swiper-bundle.css'

import SwiperClass from './../../../../../../js/classes/Swiper.js'

import './styles.scss'

Swiper.use([ Autoplay ])

SwiperClass.init('.comments .swiper-container', {
    direction: 'horizontal',
        
    autoplay: true,
    
    delay: 6000,
    
    loop : true,

    slidesPerView: 'auto',

    spaceBetween: 20,

    breakpoints: {
        520: {
            slidesPerView: 1,
        },
        720: {
            slidesPerView: 'auto',
        },
    },
})